import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Check, ArrowRight, ChevronDown, Gift } from 'lucide-react';
export function OfferSummary() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [showBonusInfo, setShowBonusInfo] = useState(false);
  const products = [{
    image: 'https://cdn.magicpatterns.com/uploads/qThLRYxDvrmmpUiuCbHsaz/Imagen_Hero.png',
    name: 'NEURO RESET Somático',
    description: 'Guía de trabajo completa con 6 Pilares, checklists, ejercicios y plan de 7 días',
    tag: 'PRODUCTO PRINCIPAL',
    tagColor: 'bg-muted-teal'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/pmjE4Xt8LhDCQVx3zzgZbf/Bono_1.jpg',
    name: 'Audio SOS: Calma Instantánea',
    description: 'El botón de pánico de emergencia para cortar la ansiedad en 3 minutos',
    tag: 'BONO 1',
    tagColor: 'bg-amber-gold'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/a3Ev9LpXf1mxwUCFcAyCs1/Bono_2.jpg',
    name: 'Pack 7 Sesiones de Neuro-Hipnosis',
    description: 'Para automatizar la calma y mejorar el sueño a nivel subconsciente',
    tag: 'BONO 2',
    tagColor: 'bg-amber-gold'
  }];
  return <section id="precio" ref={ref} className="w-full px-6 py-10 bg-gradient-to-b from-dark-navy via-amber-gold/10 to-dark-navy" data-id="element-124">
      <div className="max-w-3xl mx-auto" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-126">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold mb-10 text-center" data-id="element-127">
            Lo que recibes hoy
          </h2>

          <div className="space-y-4 mb-8" data-id="element-128">
            {products.map((product, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {
            opacity: 0,
            x: -20
          }} transition={{
            delay: index * 0.12,
            duration: 0.5
          }} className="bg-warm-cream/5 border border-warm-cream/10 rounded-xl p-4 md:p-5 flex items-center gap-4" data-id="element-129">
                <img src={product.image} alt={product.name} className="w-16 h-16 md:w-20 md:h-20 rounded-lg object-cover flex-shrink-0" data-id="element-130" />
                <div className="flex-1 min-w-0" data-id="element-131">
                  <span className={`${product.tagColor} text-dark-navy text-xs font-bold px-2 py-0.5 rounded-full`} data-id="element-132">
                    {product.tag}
                  </span>
                  <h4 className="font-playfair text-lg md:text-xl font-semibold mt-1 leading-tight" data-id="element-133">
                    {product.name}
                  </h4>
                  <p className="text-warm-cream/60 text-sm mt-0.5" data-id="element-134">
                    {product.description}
                  </p>
                </div>
                <div className="flex-shrink-0" data-id="element-135">
                  <div className="w-7 h-7 rounded-full bg-amber-gold flex items-center justify-center" data-id="element-136">
                    <Check className="w-4 h-4 text-dark-navy" strokeWidth={3} data-id="element-137" />
                  </div>
                </div>
              </motion.div>)}
          </div>

          {/* Bonus info toggle */}
          <div className="text-center mb-8" data-id="element-138">
            <button onClick={() => setShowBonusInfo(!showBonusInfo)} className="inline-flex items-center gap-2 text-amber-gold hover:text-amber-gold/80 transition-colors text-sm md:text-base font-medium" data-id="element-139">
              <Gift className="w-4 h-4" data-id="element-140" />
              Información sobre los Bonos
              <motion.div animate={{
              rotate: showBonusInfo ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-141">
                <ChevronDown className="w-4 h-4" data-id="element-142" />
              </motion.div>
            </button>
          </div>

          <AnimatePresence data-id="element-143">
            {showBonusInfo && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.35
          }} className="overflow-hidden mb-8" data-id="element-144">
                <div className="space-y-6" data-id="element-145">
                  {/* Bono 1 info */}
                  <div className="bg-amber-gold/10 border border-amber-gold/20 rounded-xl p-6" data-id="element-146">
                    <div className="flex items-center gap-3 mb-3" data-id="element-147">
                      <img src="https://cdn.magicpatterns.com/uploads/pmjE4Xt8LhDCQVx3zzgZbf/Bono_1.jpg" alt="Audio SOS" className="w-12 h-12 rounded-lg object-cover" data-id="element-148" />
                      <div data-id="element-149">
                        <span className="bg-amber-gold text-dark-navy text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-150">
                          BONO 1
                        </span>
                        <h5 className="font-playfair text-lg font-semibold mt-1" data-id="element-151">
                          Audio SOS: Calma Instantánea
                        </h5>
                      </div>
                    </div>
                    <p className="text-warm-cream/80 text-sm mb-3" data-id="element-152">
                      Un audio de emergencia de menos de 3 minutos que te guía a
                      través de una secuencia de respiración y regulación
                      somática diseñada para detener la espiral ansiosa en seco.
                    </p>
                    <ul className="space-y-1.5 text-sm text-warm-cream/70" data-id="element-153">
                      <li className="flex items-start gap-2" data-id="element-154">
                        <span className="text-amber-gold mt-0.5" data-id="element-155">•</span>
                        En el pico de una crisis de ansiedad
                      </li>
                      <li className="flex items-start gap-2" data-id="element-156">
                        <span className="text-amber-gold mt-0.5" data-id="element-157">•</span>
                        Cuando sientes el pecho apretado sin saber por qué
                      </li>
                      <li className="flex items-start gap-2" data-id="element-158">
                        <span className="text-amber-gold mt-0.5" data-id="element-159">•</span>
                        Antes de una situación que te genera estrés
                        anticipatorio
                      </li>
                      <li className="flex items-start gap-2" data-id="element-160">
                        <span className="text-amber-gold mt-0.5" data-id="element-161">•</span>A las
                        3AM cuando la mente empieza su loop nocturno
                      </li>
                    </ul>
                    <p className="text-amber-gold text-sm font-medium mt-3" data-id="element-162">
                      No necesitas estar en calma para usarlo. Está diseñado
                      para el peor momento.
                    </p>
                  </div>

                  {/* Bono 2 info */}
                  <div className="bg-amber-gold/10 border border-amber-gold/20 rounded-xl p-6" data-id="element-163">
                    <div className="flex items-center gap-3 mb-3" data-id="element-164">
                      <img src="https://cdn.magicpatterns.com/uploads/a3Ev9LpXf1mxwUCFcAyCs1/Bono_2.jpg" alt="Pack Audios Premium" className="w-12 h-12 rounded-lg object-cover" data-id="element-165" />
                      <div data-id="element-166">
                        <span className="bg-amber-gold text-dark-navy text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-167">
                          BONO 2
                        </span>
                        <h5 className="font-playfair text-lg font-semibold mt-1" data-id="element-168">
                          Pack 7 Sesiones de Neuro-Hipnosis
                        </h5>
                      </div>
                    </div>
                    <p className="text-warm-cream/80 text-sm mb-3" data-id="element-169">
                      Reprograman tu sistema nervioso mientras duermes o
                      descansas, automatizando la respuesta de calma a nivel
                      subconsciente. No tienes que esforzarte — solo dale al
                      play.
                    </p>
                    <div className="space-y-1.5 text-sm text-warm-cream/70" data-id="element-170">
                      <p className="flex items-start gap-2" data-id="element-171">
                        <span className="text-amber-gold font-bold" data-id="element-172">1.</span>{' '}
                        Inducción al sueño profundo
                      </p>
                      <p className="flex items-start gap-2" data-id="element-173">
                        <span className="text-amber-gold font-bold" data-id="element-174">2.</span>{' '}
                        Corte de rumiación nocturna
                      </p>
                      <p className="flex items-start gap-2" data-id="element-175">
                        <span className="text-amber-gold font-bold" data-id="element-176">3.</span>{' '}
                        Reprogramación de la respuesta al estrés
                      </p>
                      <p className="flex items-start gap-2" data-id="element-177">
                        <span className="text-amber-gold font-bold" data-id="element-178">4.</span>{' '}
                        Regulación del sistema nervioso autónomo
                      </p>
                      <p className="flex items-start gap-2" data-id="element-179">
                        <span className="text-amber-gold font-bold" data-id="element-180">5.</span>{' '}
                        Restauración de energía profunda
                      </p>
                      <p className="flex items-start gap-2" data-id="element-181">
                        <span className="text-amber-gold font-bold" data-id="element-182">6.</span>{' '}
                        Anclaje de seguridad interior
                      </p>
                      <p className="flex items-start gap-2" data-id="element-183">
                        <span className="text-amber-gold font-bold" data-id="element-184">7.</span>{' '}
                        Integración y reset total
                      </p>
                    </div>
                    <p className="text-amber-gold text-sm font-medium mt-3" data-id="element-185">
                      Resultado en 14 días: tu sistema nervioso aprende que la
                      calma es su estado natural.
                    </p>
                  </div>
                </div>
              </motion.div>}
          </AnimatePresence>

          {/* Price */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          delay: 0.3,
          duration: 0.5
        }} className="text-center mb-10" data-id="element-186">
            <p className="text-warm-cream/60 text-lg mb-2" data-id="element-187">
              Todo esto por solo
            </p>
            <div className="flex items-center justify-center gap-3" data-id="element-188">
              <span className="font-playfair text-6xl md:text-8xl font-bold text-amber-gold" data-id="element-189">
                $6.39
              </span>
            </div>
            <p className="text-warm-cream/50 mt-3 text-sm md:text-base" data-id="element-190">
              Menos que un café. Más que una noche de sueño real.
            </p>
          </motion.div>

          {/* CTA */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {
          opacity: 0,
          scale: 0.95
        }} transition={{
          delay: 0.4,
          duration: 0.5
        }} className="text-center" data-id="element-191">
            <motion.a href="https://dobolia.com/cart/64087943414109:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="bg-amber-gold text-dark-navy font-bold text-lg md:text-xl px-12 py-6 rounded-full inline-flex items-center gap-3 shadow-2xl hover:shadow-amber-gold/20 transition-all no-underline" data-id="element-192">
              SÍ, QUIERO MI NEURO RESET SOMÁTICO + LOS DOS BONOS
              <ArrowRight className="w-6 h-6" strokeWidth={2.5} data-id="element-193" />
            </motion.a>
            <p className="text-warm-cream/60 mt-4 text-sm md:text-base" data-id="element-194">
              Acceso inmediato. Sin esperas. Empieza esta noche.
            </p>
            <p className="text-warm-cream/40 mt-1 text-xs md:text-sm" data-id="element-195">
              Garantía de satisfacción de 7 días.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}